import { trackSnowplow, TrackingType } from './snowplow'
import { getCookie } from 'utils/cookie'

export { TrackingType }

interface TrackingEventPayload {
  form_name: string
  event_name: string
  field_value: string
}

interface TrackingOptions {
  type?: TrackingType
  schema: string
  payload: TrackingEventPayload
}

export async function trackEvent({
  type = TrackingType.REALTIME,
  schema,
  payload,
}: TrackingOptions) {
  const sessionId = !getCookie('reg_ust')
    ? getCookie('reg_ust')
    : getCookie('ust')

  const trackingPayload = {
    memberlogin: '',
    ptnr: 'direct_homepage',
    platform: 'web',
    session_id: sessionId,
    form_name: payload.form_name,
    event_name: payload.event_name,
    field_value: payload.field_value,
  }

  console.log('$$ Tracking', type, { ...trackingPayload }) // Copied to prevent gc

  trackSnowplow({
    schema,
    trackingType: type,
    data: trackingPayload,
  })
}
